module.exports = __webpack_public_path__ + "img/align_center_hotizontally.5e0a650a.svg";